import { api } from '@/shared/axios-client';

/** One row from Mongo `scriptsFiles` (test script inventory). */
export interface TestScriptFileRow {
  filePath?: string | null;
  fileName?: string | null;
  contentHash?: string | null;
  size?: number | null;
  status?: 'active' | 'removed' | null;
  createdAt?: string | null;
  removedAt?: string | null;
}

/** `data` payload from GET /api/repositories/{id}/test-script-files on success. */
export interface TestScriptFilesPayload {
  repositoryId: string;
  repoName?: string;
  inventoryId: string;
  totalCount: number;
  skip: number;
  limit: number;
  files: TestScriptFileRow[];
}

export interface TestScriptFilesServiceResponse {
  success: boolean;
  statusCode: number;
  message: string;
  data: TestScriptFilesPayload | null;
}

/**
 * Listed test script files indexed during onboarding (Katalon/groovy inventory).
 * `repositoryMongoId` must be the code repository MongoDB `_id` (same as `dbRepoId` in the UI).
 */
export async function getTestScriptFiles(
  repositoryMongoId: string,
  options?: { skip?: number; limit?: number },
): Promise<TestScriptFilesServiceResponse> {
  const skip = options?.skip ?? 0;
  const limit = options?.limit ?? 100;
  const res = (await api.get(
    `/api/repositories/${encodeURIComponent(repositoryMongoId)}/test-script-files`,
    { params: { skip, limit } },
  )) as TestScriptFilesServiceResponse;
  return res;
}



